import React from 'react';
import { Icon } from '@/components/Icons';
import { SectionHeading } from '@/components/SectionHeading';
import { RevealGroup, RevealItem } from '@/components/Reveal';

export const Capabilities = ({ capabilities = [] }) => {
  if (!capabilities.length) return null;
  return (
    <section className='bg-[#F6F5F1] pb-20 lg:pb-28'>
      <div className='container-x'>
        <SectionHeading eyebrow='Core Capabilities' title='Built to move earth. Built to move projects.' />
        <RevealGroup className='mt-12 grid gap-px overflow-hidden rounded-2xl border border-[#20272A]/10 bg-[#20272A]/10 sm:grid-cols-2 lg:grid-cols-4'>
          {capabilities.map((c) => (
            <RevealItem key={c.title}>
              <div className='group h-full bg-[#F6F5F1] p-7 transition-colors duration-300 hover:bg-white'>
                <div className='flex h-12 w-12 items-center justify-center rounded-xl bg-[#075B61]/8 text-[#075B61] transition-colors duration-300 group-hover:bg-[#075B61] group-hover:text-[#F6F5F1]'>
                  <Icon name={c.icon} size={24} />
                </div>
                <h3 className='mt-5 font-head text-lg font-semibold text-[#20272A]'>{c.title}</h3>
                <p className='mt-2 text-sm leading-relaxed text-[#20272A]/60'>{c.text}</p>
                <span className='mt-5 block h-px w-0 bg-[#B88A3B] transition-all duration-500 group-hover:w-12' />
              </div>
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
};
